import { put, retry, all } from 'redux-saga/effects';
import { authClient } from '../api/Client';
import { reject, resolve } from '../api';
import * as types from '../constants';
import {
  showNotification,
  simpleErrorNotification,
  successNotification,
} from '../../shared-components/Notifications';

export function* deleteSPQLQuery({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient.DeepScan.deleteSPQLQuery, {
      uuid: uuid,
    });
    if (
      res.responseStatus === 200 ||
      res.responseStatus === 201 ||
      res.responseStatus === 204
    ) {
      yield all([
        put({
          type: resolve(types.DELETE_SPQL_QUERY),
          payload: uuid,
        }),
        showNotification(
          successNotification({
            message: 'Web Scanner query deleted successfully.',
          }),
        ),
      ]);
      return;
    }
    yield all([
      put({
        type: reject(types.DELETE_SPQL_QUERY),
        res,
      }),
      showNotification(
        simpleErrorNotification({
          statusCode: res?.responseStatus,
          message:
            JSON.parse(res?.responseData)?.errors?.[0]?.message ??
            'Deleting Web Scanner query was unsuccessful.',
        }),
      ),
    ]);
  } catch (error) {}
}

export function* updateSPQLQuery({
  uuid,
  name,
  scope,
  description,
  query,
  sorting,
}) {
  try {
    const res = yield retry(4, 500, authClient.DeepScan.updateSPQLQuery, {
      uuid: uuid,
      body: {
        name: name,
        scope: scope,
        description: description,
        query: query,
        sorting: sorting,
      },
    });
    if (
      res.responseStatus === 200 ||
      res.responseStatus === 201 ||
      res.responseStatus === 204
    ) {
      yield all([
        put({
          type: resolve(types.UPDATE_SPQL_QUERY),
          payload: res?.data(),
        }),
        showNotification(
          successNotification({
            message: 'Web Scanner query updated successfully.',
          }),
        ),
      ]);
      return;
    }
    yield all([
      put({
        type: reject(types.UPDATE_SPQL_QUERY),
        res,
      }),
      showNotification(
        simpleErrorNotification({
          statusCode: res?.responseStatus,
          message:
            JSON.parse(res?.responseData)?.errors?.[0]?.message ??
            'Updating Web Scanner query was unsuccessful.',
        }),
      ),
    ]);
  } catch (error) {}
}

export function* createSPQLQuery({ query, sorting, name, description }) {
  try {
    const res = yield retry(4, 500, authClient.DeepScan.createSPQLQuery, {
      body: {
        query: query,
        sorting: sorting,
        name: name,
        description: description,
      },
    });
    if (
      res.responseStatus === 200 ||
      res.responseStatus === 201 ||
      res.responseStatus === 204
    ) {
      yield all([
        put({
          type: resolve(types.CREATE_SPQL_QUERY),
          payload: res?.data(),
        }),
        showNotification(
          successNotification({
            message: 'Web Scanner query created successfully.',
          }),
        ),
      ]);
      return;
    }
    yield all([
      put({
        type: reject(types.CREATE_SPQL_QUERY),
        res,
      }),
      showNotification(
        simpleErrorNotification({
          statusCode: res?.responseStatus,
          message:
            JSON.parse(res?.responseData)?.errors?.[0]?.message ??
            'Creating Web Scanner query was unsuccessful.',
        }),
      ),
    ]);
  } catch (error) {}
}

export function* getSavedSPQLQueries() {
  try {
    const res = yield retry(4, 500, authClient.DeepScan.getSavedSPQLQueries);
    yield put({
      type: resolve(types.GET_SAVED_SPQL_QUERIES),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.GET_SAVED_SPQL_QUERIES),
        error,
      }),
    ]);
  }
}

export function* getQueryExamples() {
  try {
    console.log('here is the result');
    const res = yield retry(4, 500, authClient.DeepScan.getQueryExamples);
    yield put({
      type: resolve(types.GET_QUERY_EXAMPLES),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.GET_QUERY_EXAMPLES),
        error,
      }),
    ]);
  }
}

export function* getRecentlyRanSPQLQueries() {
  try {
    const res = yield retry(4, 500, authClient.DeepScan.getRecentQueries);
    yield put({
      type: resolve(types.GET_RECENTLY_RAN_SPQL_QUERIES),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.GET_RECENTLY_RAN_SPQL_QUERIES),
        error,
      }),
    ]);
  }
}

export function* getDeepScan({ query, sort, limit, skip }) {
  try {
    const res = yield retry(4, 500, authClient.DeepScan.query, {
      body: {
        query: query,
        sort: sort,
      },
      limit: limit,
      skip: skip,
      with_metadata: 1,
      max_wait: 1,
    });
    yield put({
      type: resolve(types.GET_DEEP_SCAN),
      payload: {
        ...res?.data(),
        query: query,
        sort: sort,
        currentPage: skip / limit + 1,
      },
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.GET_DEEP_SCAN),
        error,
      }),
    ]);
  }
}

export function* getDeepScanMetadata() {
  try {
    const res = yield retry(4, 500, authClient.DeepScan.getMetadata);
    yield put({
      type: resolve(types.GET_DEEP_SCAN_METADATA),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types.GET_DEEP_SCAN_METADATA),
        error,
      }),
    ]);
  }
}
